import { render, staticRenderFns } from "./ElDivider.vue?vue&type=template&id=0df6072d"
import script from "./ElDivider.vue?vue&type=script&lang=js"
export * from "./ElDivider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports